<template>
  <el-dialog
    :title="$t('affiliateRelationManage.editRelation')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form :model="editAffiliateRelationInfo" :rules="rules" ref="editForm" label-width="120px">
      <el-form-item :label="$t('affiliateRelationManage.relationLevel')" prop="name">
        <el-input
          v-model="editAffiliateRelationInfo.name"
          :placeholder="$t('affiliateRelationManage.relationLevelRequired')"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('affiliateRelationManage.expireTime')" prop="expireTime">
        <el-input
          v-model="editAffiliateRelationInfo.expireTime"
          :placeholder="$t('affiliateRelationManage.expireTimeRequired')"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="updateAffiliateRelationInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateAffiliateRelation } from '@/api/affiliate/affiliateRelationApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditAffiliateRelation',
  data() {
    return {
      dialogVisible: false,
      editAffiliateRelationInfo: {
        arId: '',
        name: '',
        expireTime: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('affiliateRelationManage.relationLevelRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('affiliateRelationManage.relationLevelMaxLength'), trigger: 'blur' }
        ],
        expireTime: [
          { required: true, message: this.$t('affiliateRelationManage.expireTimeRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('affiliateRelationManage.expireTimeMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.editAffiliateRelationInfo = {
        arId: row.arId,
        name: row.name || row.relationLevel,
        expireTime: row.expireTime
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.editForm.resetFields()
    },
    updateAffiliateRelationInfo() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        
        this.editAffiliateRelationInfo.shopId = getShopId()
        updateAffiliateRelation(this.editAffiliateRelationInfo)
          .then(res => {
            if (res.code === 0) {
              this.$message.success(this.$t('common.saveSuccess'))
              this.dialogVisible = false
              this.$emit('refresh')
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(error => {
            this.$message.error(this.$t('common.saveFailed'))
            console.error('请求失败处理:', error)
          })
      })
    }
  }
}
</script>